import react from "react";
import Background from "../../assets/images/background.jpg";
import LearningHubImage from "../../assets/images/learning-hub.png";
import { Link } from "react-router-dom";

const LearningHub = () => {
  return (
    <div className="mt-24 ">
      <main className="w-full md:w-[85%] mx-auto px-4 py-0">
        <div className="container mx-auto px-4 py-2">
          <div className="flex justify-center md:justify-start">
            <div className="text-xl font-medium rounded-full px-4 py-2 bg-white border border-gray-200 shadow-sm">
              yslearn Learning Hub+
            </div>
          </div>
        </div>
        <div className="flex flex-col md:flex-row items-center gap-8 md:gap-16">
          {/* Left Column - Text Content */}
          <div className="w-full md:w-1/2 space-y-6">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight">
              <span className="text-black">Empower </span>
              <span className="text-blue-400">your </span>
              <span className="text-green-400">team </span>
              <br className="hidden md:block" />
              <span className="text-teal-400">with skills </span>
              <span className="text-black">for the future</span>
            </h1>

            <p className="text-lg md:text-xl text-gray-800 max-w-xl">
              Get a learning library with live and interactive solutions,
              covering AI and other digital skills.
            </p>
          <Link to={'/login'}>
            <button className="bg-blue-500 hover:bg-blue-600 text-white px-8 py-2 text-lg rounded-md">
              Get A Free Trial
            </button>
          </Link>
          </div>

          {/* Right Column - Image */}
          <div className="w-full md:w-1/2 relative">
            <div className="relative">
              <div className="!absolute inset-0  rounded-3xl translate-x-0 translate-y-0 z-0"></div>
              <div className="relative z-10 rounded-3xl overflow-hidden ">
                <img
                  src={Background}
                  alt="Person learning online"
                  width={800}
                  height={600}
                  className="w-full h-auto"
                />

                {/* Video Play Overlay */}
                <div className="!absolute top-0 inset-0 flex flex-col items-center justify-center">
                  {/* <video
                    className="rounded-3xl"
                    width="800"
                    height="600"
                    controls
                    autoPlay
                  >
                    <source
                      src="/path-to-your-video/video.mp4"
                      type="video/mp4"
                    />
                    Your browser does not support the video tag.
                  </video> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};
export default LearningHub;
